var exports = {
  "zr": "ScreenShareBufferingFrame.module__root___bHNZdT",
  "WO": "ScreenShareBufferingFrame.module__corner___bHNZdT",
  "u1": "ScreenShareBufferingFrame.module__spinner___bHNZdT",
  "MI": "ScreenShareBufferingFrame.module__failureContent___bHNZdT",
  "nV": "ScreenShareBufferingFrame.module__failureTitle___bHNZdT",
  "eB": "ScreenShareBufferingFrame.module__failureSubtext___bHNZdT",
  "sM": "ScreenShareBufferingFrame.module__srOnly___bHNZdT",
  "Om": "ScreenShareBufferingFrame.module__dot___bHNZdT",
  "wV": "ScreenShareBufferingFrame.module__dot0___bHNZdT",
  "TQ": "ScreenShareBufferingFrame.module__dot1___bHNZdT",
  "Mc": "ScreenShareBufferingFrame.module__dot2___bHNZdT",
  "FA": "ScreenShareBufferingFrame.module__dot3___bHNZdT",
  "yY": "ScreenShareBufferingFrame.module__dot4___bHNZdT",
  "Ff": "ScreenShareBufferingFrame.module__dot5___bHNZdT",
  "Mi": "ScreenShareBufferingFrame.module__dot6___bHNZdT",
  "FG": "ScreenShareBufferingFrame.module__dot7___bHNZdT",
  "MZ": "ScreenShareBufferingFrame.module__dot8___bHNZdT",
};

module.exports = exports;
